export const environment = {
  production: true,
  imagePrefix: 'assets/images/',
  // apiUrl: 'https://d36hb3uugw8h3l.cloudfront.net/',
  apiUrl: 'https://next-stable.xpresion.in/api/',
  // apiUrl: 'https://dev.api.xpresion.in/api/',
  s3DomainURL: 'https://xpresion-files-prod.s3.ap-south-1.amazonaws.com/',
  // s3DomainURL: 'https://xpresion-files-development.s3.ap-south-1.amazonaws.com/',
  // s3DomainURL: 'https://xpresion-files-development.s3.ap-south-1.amazonaws.com/',
  apiTokenizationEnabled: false,
};
